import React, { forwardRef, useMemo } from 'react';
import { TypeAnimation } from 'react-type-animation';
import { useLocale } from '../../context/LocaleContext';

const HeroPitchCard = forwardRef(function HeroPitchCard(_props, ref) {
  const { t, lang } = useLocale();

  const typeSequence = useMemo(
    () => [
      t('hero_type_1'),
      1800,
      t('hero_type_2'),
      1800,
      t('hero_type_3'),
      1800,
      t('hero_type_4'),
      1800,
    ],
    [t, lang],
  );

  return (
    <article ref={ref} className="hero-zone hero-zone--manifest rihen-hero-panel rihen-hero-panel--pitch">
      <h1 className="hero-manifest__title">
        {t('hero_title_line1')}
        <em>{t('hero_title_line2')}</em>
      </h1>

      <div className="hero-zone__rail" aria-hidden="true">
        <span className="hero-zone__rail-dot" />
      </div>

      <div className="hero-manifest" data-depth="0.08">
        <p className="hero-manifest__lead">{t('hero_lead')}</p>

        <div className="hero-manifest__meta">
          <p className="hero-manifest__name">{t('hero_name')}</p>
          <p className="hero-manifest__role">{t('hero_role')}</p>
        </div>

        <div className="hero-manifest__typewrap" aria-live="polite">
          <span className="hero-manifest__prompt" aria-hidden="true">&gt;</span>
          <span className="hero-manifest__type-label">{t('hero_type_label')}</span>
          <TypeAnimation
            key={lang}
            sequence={typeSequence}
            wrapper="span"
            speed={48}
            className="hero-manifest__type"
          />
        </div>
      </div>
    </article>
  );
});

export default HeroPitchCard;
